"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectDomainLocale = void 0;
var detectDomainLocale = function detectDomainLocale() {
  if (process.env.__NEXT_I18N_SUPPORT) {
    var _require;
    return (_require = require('../shared/lib/i18n/detect-domain-locale')).detectDomainLocale.apply(_require, arguments);
  }
};
exports.detectDomainLocale = detectDomainLocale;
if ((typeof exports.default === 'function' || _typeof(exports.default) === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}